import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY;

const supabase = createClient(supabaseUrl ?? "", supabaseKey ?? "");

// Bearer tokens used for API calls are mirrored into sessionStorage ('token' for
// regular users, 'adminToken' for the super-admin portal, 'complianceToken' for the
// compliance portal) instead of being read from Supabase's own session on every
// request. Keep those mirrors in sync with the client's background token refresh,
// and clear them if the session is ever fully signed out (explicit logout, or the
// refresh token itself expiring).
const MIRRORED_TOKEN_KEYS = ['token', 'adminToken', 'complianceToken'];

supabase.auth.onAuthStateChange((event, session) => {
  if (event === 'TOKEN_REFRESHED' && session?.access_token) {
    for (const key of MIRRORED_TOKEN_KEYS) {
      if (sessionStorage.getItem(key)) sessionStorage.setItem(key, session.access_token);
    }
  }
  if (event === 'SIGNED_OUT') {
    for (const key of MIRRORED_TOKEN_KEYS) sessionStorage.removeItem(key);
  }
});

export default supabase;
